<template>
    <v-app>
        <TicketAlertsAudio v-if="isLoggedIn" />
        <v-snackbar
            v-for="(snackbar, index) in snackbars.filter(snackbar => snackbar.showing)"
            :key="snackbar.text + Math.random()"
            v-model="snackbar.showing"
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            :style="`top: ${(index * 60) }px`"
            right
            top
            text
        >
            <v-icon
                :color="snackbar.color"
            >
                check_circle_outline
            </v-icon>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <div
                    :color="snackbar.color"
                    text
                    v-bind="attrs"
                    :style="`margin-right:.1px`"
                    @click="snackbar.showing = false"
                >
                    <v-icon :color="snackbar.color">
                        close
                    </v-icon>
                </div>
            </template>
        </v-snackbar>
        <UploadOfflineDialog />
        <component :is="this.$route.meta.layout">
            <router-view />
        </component>
    </v-app>
</template>

<script>
import TicketAlertsAudio from './components/TicketAlerts/TicketAlertsAudio.vue';
import UploadOfflineDialog from './components/Offline/UploadOfflineDialog.vue';

export default {
    name: 'App',
    components: {
        TicketAlertsAudio,
        UploadOfflineDialog,
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        // ...mapState(['snackbars']),
        snackbars(){
            return this.$store.getters.snackbars;
        }
    },
};
</script>
<style>
.custom-icon {
  fill: currentColor;
}
.v-data-table {
    border: .5px solid var(--ll-border);
 }
</style>
